function formatComponentName (vm) {
  if (vm.$root === vm) {
    return 'root instance';
  }
  /* eslint-disable */
  const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
  );
};

export const vueErrorHandel = (error, vm, info) => {
  const metaData = {};
  // vm and lifecycleHook are not always available
  if (Object.prototype.toString.call(vm) === '[object Object]') {
    metaData.componentName = formatComponentName(vm);
    metaData.propsData = vm.$options && vm.$options.propsData;
  }
  if (info && typeof info !== 'undefined') {
    metaData.lifecycleHook = info;
  }
  if (window.Owl) {
    window.Owl.addError(error, {
      tags: metaData,   //tags<Object> 自定义错误信息
    });
  }
  console.error(error);
};

/**
 * CAT 错误上报
 *
 * API文档 https://docs.sankuai.com/dp/f2e/owl/xjj/firstScreen-interactive/intro/api/#adderrorerror-opts
 *
 * @param error
 *        - error<Object|Required>: 错误对象，支持string、object、error实例，可参考下面Demo
 *        Demo: https://docs.sankuai.com/dp/f2e/owl/xjj/firstScreen-interactive/intro/demo/#_4
 *
 * @param opts
 *        - combo<Boolean>: 值为false时立刻上报错误，否则读取config中的error对象中的combo配置
 *        - level: 错误级别，默认error，可参考下面的错误类型和分类
 *        - category: 错误分类，默认jsError，可参考下面的错误类型和分类
 *        - tags<Object>: 其他错误信息
 *        错误类型和分类: https://docs.sankuai.com/dp/f2e/owl/xjj/firstScreen-interactive/intro/intro/#_4
 */
export const addError = (error, opts = {
  combo: false,
  level: 'error',
  category: 'jsError',
  tags: {}
}) => {
  if (window.Owl) {
    window.Owl.addError(error, opts);
  }
};



// WEBPACK FOOTER //
// ./src/components/util/vueErrorHandel.js